import { useEffect, useState } from "react";
import { api } from "../../lib/api";

/** Módulos que el admin/super-admin puede apagar por organización.
 *  La clave coincide con MODULO_POR_RUTA en tienda.tsx (gating del menú). */
const MODULOS: { key: string; label: string; desc: string }[] = [
  { key: "delivery", label: "Delivery", desc: "Pedidos a domicilio y zonas de envío" },
  { key: "pagos_reservas", label: "Pagos de reserva", desc: "Cobro anticipado para garantizar la reserva" },
  { key: "walkin", label: "Lista de espera (walk-in)", desc: "Clientes sin reserva se anotan escaneando el QR de la puerta" },
  { key: "encuestas", label: "Encuestas", desc: "Encuestas de satisfacción y QR" },
  { key: "eventos", label: "Eventos privados", desc: "Gestión de eventos y checklist" },
  { key: "eventos_publicos", label: "Eventos públicos", desc: "Venta de entradas con pago anticipado y cupo reservado" },
  { key: "audiencias", label: "Audiencias", desc: "Segmentos y campañas de marketing" },
  { key: "marketing_automatico", label: "Marketing automático", desc: "Cumpleaños y reenganche de clientes inactivos, sin que nadie tenga que mandarlo a mano" },
  { key: "cliente360", label: "Cliente 360°", desc: "Ficha e historial del cliente" },
  { key: "reportes", label: "Reportes", desc: "Tableros y reportes del negocio" },
  { key: "whatsapp", label: "WhatsApp", desc: "Mensajería automática" },
  { key: "qr", label: "Códigos QR", desc: "QR de mesas y menú" },
  { key: "calendario", label: "Calendario", desc: "Vista de calendario de reservas" },
];

export function ModulosPage() {
  const [modulos, setModulos] = useState<Record<string, boolean>>({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    api<Record<string, boolean>>("/v1/sucursales/org-modulos")
      .then((m) => setModulos(m ?? {}))
      .catch(() => setModulos({}))
      .finally(() => setLoading(false));
  }, []);

  const activo = (k: string) => modulos[k] !== false;
  const toggle = (k: string) => setModulos((m) => ({ ...m, [k]: !(m[k] !== false) }));

  const guardar = async () => {
    setSaving(true);
    setSaved(false);
    try {
      await api("/v1/sucursales/org-modulos", { method: "PUT", body: { modulos } });
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="mx-auto max-w-3xl px-4 py-8 text-ink-500">Cargando módulos…</div>;
  }

  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 py-8 animate-fade-in">
      <h1 className="font-display text-2xl font-bold text-ink-800 mb-1">Módulos del cliente</h1>
      <p className="text-sm text-ink-500 mb-6">
        Activá o desactivá los módulos que usa esta organización. Los desactivados desaparecen
        del menú para todos sus usuarios. Los cambios se aplican al volver a iniciar sesión.
      </p>

      <div className="space-y-3">
        {MODULOS.map((m) => (
          <div key={m.key} className="card p-4 flex items-center justify-between gap-4">
            <div>
              <p className="font-semibold text-ink-800 text-sm">{m.label}</p>
              <p className="text-xs text-ink-500">{m.desc}</p>
            </div>
            <div
              onClick={() => toggle(m.key)}
              className={`w-11 h-6 rounded-full transition-colors relative cursor-pointer shrink-0 ${activo(m.key) ? "bg-brand-600" : "bg-ink-300"}`}
            >
              <div className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform ${activo(m.key) ? "translate-x-5" : "translate-x-0"}`} />
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6">
        <button onClick={guardar} disabled={saving} className="btn-primary px-6">
          {saving ? "Guardando…" : saved ? "✓ Guardado" : "Guardar módulos"}
        </button>
      </div>
    </div>
  );
}
